
define('Tavano.Klaviyo.Checkout.Sync.Checkout'
	, [
	]
	, function (

	) {
		'use strict';


		var TavanoKlaviyoCheckoutSync = {

			setCookie: function (cname, cvalue, exdays) {
				var d = new Date();
				d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
				var expires = "expires=" + d.toUTCString();
				document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
			},

			getCookie: function (cname) {
				var name = cname + "=";
				var decodedCookie = decodeURIComponent(document.cookie);
				var ca = decodedCookie.split(';');
				for (var i = 0; i < ca.length; i++) {
					var c = ca[i];
					while (c.charAt(0) == ' ') {
						c = c.substring(1);
					}
					if (c.indexOf(name) == 0) {
						return c.substring(name.length, c.length);
					}
				}
				return "";
			},




			getParentImages: function (parentImages) {

				var finalImagesProcessed = [];

				for (var prop in parentImages) {
					if (Object.prototype.hasOwnProperty.call(parentImages, prop)) {


						// Level 2

						for (var propLevel2 in parentImages[prop]) {
							if (Object.prototype.hasOwnProperty.call(parentImages[prop], propLevel2)) {

								if (propLevel2 == "url") {
									finalImagesProcessed.push(parentImages[prop][propLevel2])

								} else {


									// Level 3

									for (var propLevel3 in parentImages[prop][propLevel2]) {
										if (Object.prototype.hasOwnProperty.call(parentImages[prop][propLevel2], propLevel3)) {

											if (propLevel3 == "url") {

												finalImagesProcessed.push(parentImages[prop][propLevel2][propLevel3])

											} else {

												// Level 4

												for (var propLevel4 in parentImages[prop][propLevel2][propLevel3]) {
													if (Object.prototype.hasOwnProperty.call(parentImages[prop][propLevel2][propLevel3], propLevel4)) {

														if (propLevel4 == "url") {

															finalImagesProcessed.push(parentImages[prop][propLevel2][propLevel3][propLevel4])

														} else {
															// Level 5
															for (var propLevel5 in parentImages[prop][propLevel2][propLevel3][propLevel4]) {
																if (Object.prototype.hasOwnProperty.call(parentImages[prop][propLevel2][propLevel3][propLevel4], propLevel5)) {

																	if (propLevel5 == "url") {

																		finalImagesProcessed.push(parentImages[prop][propLevel2][propLevel3][propLevel4][propLevel5])

																	} else {
																		/// Level 6
																		for (var propLevel6 in parentImages[prop][propLevel2][propLevel3][propLevel4][propLevel5]) {
																			if (Object.prototype.hasOwnProperty.call(parentImages[prop][propLevel2][propLevel3][propLevel4][propLevel5], propLevel6)) {

																				if (propLevel6 == "url") {

																					finalImagesProcessed.push(parentImages[prop][propLevel2][propLevel3][propLevel4][propLevel5][propLevel6])

																				} else {
																					// Add more levels nestede here

																				}
																			}
																		}

																	}
																}
															}
														}
													}
												}
											}
										}
									}
								}
							}
						}
					}
				}

				return finalImagesProcessed;



			},

			addCustomFields: function (line, parentItem, environment_component, klaviyoObject, isMatrixChild) {


				try {
					var customFields = environment_component.getConfig("tavanoKlaviyo").columns.customFields || [];

					_.each(customFields, function (customField) {
						if (isMatrixChild && customField.nsidparent && customField.nsidparent != "") {

							klaviyoObject[customField.klaviyokey] = parentItem[customField.nsidparent]

						} else {

							if (customField && customField.nsid == "displayname") {
								klaviyoObject[customField.klaviyokey] = line.item.displayname
							} else {
								klaviyoObject[customField.klaviyokey] = line.item.extras[customField.nsid]
							}

						}

					})
				} catch (e) {
					console.log("Impossible to add custom fields");
					console.log(JSON.stringify(e))
				}
			},

			sendCheckoutInfo: function (cart, environment_component) {

				var self = this;

				var session = environment_component.getSession()


				var klaviyoObject = {};

				// ---------------------------
				// Currency
				// ---------------------------
				var currency_code = session.currency.code;
				var currency_name = session.currency.currencyname
				var currency_symbol = session.currency.symbol


				klaviyoObject["currency_code"] = currency_code;
				klaviyoObject["currency_name"] = currency_name;
				klaviyoObject["currency_symbol"] = currency_symbol;


				// ---------------------------
				// SiteID and Domain
				// ---------------------------
				var siteId = environment_component.getConfig("siteSettings.siteid");
				var domain = location.protocol + "//" + location.host;

				klaviyoObject["site_id"] = siteId;
				klaviyoObject["domain"] = domain;

				// ---------------------------
				// Language
				// ---------------------------
				var language_name = session.language.name;

				klaviyoObject["language_name"] = language_name;

				cart.getSummary().then(function (summary) {

					klaviyoObject["$event_id"] = Date.now().toString();
					klaviyoObject["$value"] = summary.total;
					klaviyoObject["items_subtotal"] = summary.subtotal;
					klaviyoObject["$CheckoutURL"] = location.href;

					var cartHash = "";
					cart.getLines().done(function (lines) {
	
	
						var Items = [];
	
						_.each(lines, function (line, lineIndex) {
							var dataLine = {
								"ProductID": line.item.internalid,
								"SKU": line.item.extras.keyMapping_sku,
								"ProductName": line.item.extras.displayname || line.item.extras.storedisplayname || line.item.extras.storedisplayname2,
								"Quantity": line.quantity,
								"ItemPrice": line.rate,
								"RowTotal": line.amount,
								"ProductURL": klaviyoObject["domain"] + line.item.extras.keyMapping_url,
								"ImageURL": line.item.extras.keyMapping_images.length > 0 ? line.item.extras.keyMapping_images[0].url : "",
							}
							console.log(dataLine)
							cartHash += line.item.internalid.toString() + line.quantity.toString();
							// Handle Images
	
							var matrixParent = line.item.extras.matrix_parent;
	
							self.addCustomFields(line, matrixParent, environment_component, dataLine, matrixParent)
	
							Items.push(dataLine)
	
							if (matrixParent) {
	
								// In this case the all images are related to the child
								// var allImages = _.map(line.item.extras.keyMapping_images,function(image){
								// 	return image.url
								// })
	
								var allImages = self.getParentImages(matrixParent.itemimages_detail)
								console.log(allImages);
	
								var matrixOptionValues = [];
	
								_.each(line.options, function (option) {
									if (option && option.isMatrixDimension && option.value) { }
									matrixOptionValues.push(option.value.label)
								})
	
	
								console.log(matrixOptionValues);
								var mainImage = '';
								// Now we only have to pick the Image from the entire list of images
								for (var i = 0; i < allImages.length; i++) {
									var allCheck = true;
									for (var j = 0; j < matrixOptionValues.length; j++) {
	
										var image = allImages[i].toUpperCase();
										var imgValue = matrixOptionValues[j].toUpperCase();
	
										if (image.indexOf(imgValue) != -1) {
											mainImage = allImages[i]
											break;
										} else {
											allCheck = false;
										}
									}
	
									if (mainImage) {
										break;
									}
	
									/*	if (allCheck){
											mainImage = allImages[i] //Never enters here due to lack of validation
										}*/
								}
	
								console.log('mainImage ' + mainImage);
								if (mainImage) {
									Items[lineIndex]["ImageURL"] = mainImage
								} else {
									// If we didn't found the image, we assign the first that we can
									if (allImages && allImages.length > 0) {
										console.log('allImages ' + allImages[0]);
										Items[lineIndex]["ImageURL"] = allImages[0];
									}
	
	
								}
							}
	
							// End Handle Images
	
						})
	
						var ItemNames = _.map(Items, function (item) {
							return item["ProductName"]
						})
	
						klaviyoObject["ItemNames"] = ItemNames;
						klaviyoObject["Items"] = Items;
	
						var eventData = {
							'event': 'klaviyoStartedCheckout',
							'klaviyo_data': klaviyoObject
						};
	
	
						// New event_id
						klaviyoObject["$event_id"] = cartHash;
						var previousCartHash = self.getCookie("ttkalviyocart");
						var isDifferentCart = cartHash != previousCartHash;
						if (isDifferentCart) {
							self.setCookie("ttkalviyocart", cartHash, 1);
	
						}
						isDifferentCart && !window.checkoutStarted && window["dataLayer"].push(eventData);
						window.checkoutStarted = true;
	
	
	
					});

				});


			

			}

		}

		return TavanoKlaviyoCheckoutSync;
	});
